module.exports = __webpack_public_path__ + "static/media/USDT.0b8d2118.svg";